module.exports = __webpack_public_path__ + "media/alarm.86568640.mp3";